import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_ROLE_ENDPOINT } from '@/services/org-admin';

export function useDeleteOrgRole() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);
  const userId = useAuthStoreV1((s) => s.user?.id ?? null);

  return useMutation({
    mutationFn: (roleId: string) =>
      axiosInstance.delete(ORG_ROLE_ENDPOINT(orgId!, roleId), {
        headers: {
          ...(orgId ? { 'X-Organization-ID': orgId } : {}),
          ...(userId ? { 'X-User-ID': userId } : {}),
        },
      }),
    onSuccess: () => {
      // Deleting a role nilifies role_id on any member/invitation holding it
      void queryClient.invalidateQueries({ queryKey: ['org-roles', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['org-members', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['org-invitations', orgId] });
    },
    // Caller already shows its own success/error toast — suppress the global one.
    meta: { silent: true },
  });
}
